import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {CommissionImport} from "../../../../shared/interface/commission-import";
import {interval, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {ThemePalette} from "@angular/material/core";
import {ProgressBarMode} from "@angular/material/progress-bar";
import {ReceivablesImport} from "../../../../shared/interface/receivables-import";
import { IMPORT_STATUS_IN_PROGRESS } from 'src/app/shared/services/dict.service';
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesImportsService} from "../../../../shared/services/receivables-imports.service";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {RegistrationIdImport} from "../../../../shared/interface/registration-id-import";

@Component({
  selector: 'app-all-receivables-imports-list',
  templateUrl: './all-receivables-imports-list.component.html',
  styleUrls: ['./all-receivables-imports-list.component.scss']
})
export class AllReceivablesImportsListComponent implements  AfterViewInit, OnInit, OnDestroy  {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  imports: ReceivablesImport[] = [];
  displayedColumns: string[] = [ 'tu', 'importer', 'company', 'name', 'createdAt', 'createdBy', 'sum',
    'totalRows', 'status', 'actions'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  selectedInsuranceCompanies: InsuranceCompany[] = [];
  formErrors = {};
  color: ThemePalette = 'accent';
  mode: ProgressBarMode = 'indeterminate';
  control: FormControl;
  progressBarDelete: string;
  readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private formHelper: FormHelperService,
    private receivablesImportsService: ReceivablesImportsService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesImportsService.importListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<ReceivablesImport>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();

  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      in$insuranceCompany: 'int[]',
      importer: 'int[]',
      company: 'int',
      gte$createdAt: 'string',
      lte$createdAt: 'string',
      createdBy: 'string',
      in$status: 'int[]',
    }, filters);
  }

  ngOnInit(): void {
    interval(5000)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.paginator.pageIndex === 0) {
          this.loadListData();
        }
      });
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.receivablesImportsService.loadImportList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
  deleteImport(receivablesImport: ReceivablesImport): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć import?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.progressBarDelete = receivablesImport.uuid;
        this.receivablesImportsService.deleteImport(receivablesImport.uuid)
          .subscribe((response: Uuid) => {
            const dialogRefv1 = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });

            dialogRefv1.afterClosed().subscribe(() => {
              this.snack.open('Pomyślnie usunięto import', '', {
                duration: 2000,
              });
              }
            );
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy usuwaniu pliku wystąpił błąd', error.status.toString(), {duration: 4000});
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      }
    });
  }

  trackTask(index: number, receivablesImport: ReceivablesImport): string {
    return receivablesImport.uuid;
  }

  downloadImportFile(registrationIdImport: RegistrationIdImport): void {
    this.receivablesImportsService.downloadImportFile(registrationIdImport.uuid);
  }


  downloadReport(): void {
    this.receivablesImportsService.downloadReport(this.initialFilters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }
}
